module.exports = __webpack_public_path__ + "static/media/contact_requested.864a961f.svg";